import { createReducer, on } from '@ngrx/store';
import {
  STORE_FIND_SUCCESS,
  STORE_FAILED,
  STORE_FIND,
  CHECK_BUSINESS_DAY,
  CHECK_BUSINESS_DAY_SUCCESS,
  CHECK_BUSINESS_DAY_FAILURE,
  STORE_CLOSED,
  STORE_UPDATE_LOADING,
  STORE_RESET_STATE,
  STORE_FIND_LOCATION_SUCCESS,
  STORE_FIND_LOCATION_FAILURE,
  STORE_FIND_ALL_SUCCESS,
  STORE_IS_MULTI_UPDATE,
  WORK_DAY_FIND_SUCCESS
} from '../actions';
import { ClientLocation, PaymentResult, Store, WorkDay } from '@core/models';
import { IResponseBadRequest } from '@core/interfaces';

export interface StoreState {
  isMultiStore: boolean;
  store: Store | null;
  storeList: Store[] | null;
  loading: boolean;
  error: IResponseBadRequest | PaymentResult | null | string;
  workDay: WorkDay | null;
  isOpen: boolean | null;
  location: ClientLocation | null;
}

export const initialState: StoreState = {
  isMultiStore: false,
  store: null,
  storeList: null,
  loading: false,
  error: null,
  workDay: null,
  isOpen: null,
  location: null
};

export const storeReducer = createReducer(
  initialState,
  on(STORE_FIND_SUCCESS, (state, { store }) => ({...state, store })),
  on(STORE_FAILED, (state, { error }) => ({...state, error })),
  on(STORE_FIND, (state) => ({...state,loading: true,})),
  on(STORE_UPDATE_LOADING, (state, { loading }) => ({...state, loading })),
  on(STORE_IS_MULTI_UPDATE, (state, { isMultiStore }) => ({...state, isMultiStore })),
  on(STORE_RESET_STATE, (state) => ({...initialState })),
  on(STORE_FIND_ALL_SUCCESS, (state, { storeList }) => ({...state, storeList })),
  on(CHECK_BUSINESS_DAY, (state) => ({...state,loading: true})),
  on(CHECK_BUSINESS_DAY_SUCCESS, (state, { workDay }) => ({...state,workDay,isOpen: workDay?.estaAbierto || false,loading: false})),
  on(CHECK_BUSINESS_DAY_FAILURE, (state, { error }) => ({...state,loading: false, error})),
  on(STORE_CLOSED, (state, { message }) => ({...state,isOpen: false,storeClosedMessage: message})),
  on(STORE_FIND_LOCATION_SUCCESS, (state, { location }) => ({...state,location})),
  on(STORE_FIND_LOCATION_FAILURE, (state, { error }) => ({...state,error})),
  on(STORE_FIND_ALL_SUCCESS, (state, { storeList }) => ({...state,storeList,error: null})),
  on(STORE_IS_MULTI_UPDATE, (state, { isMultiStore }) => ({...state,isMultiStore})),
  on(WORK_DAY_FIND_SUCCESS, (state, { workDay }) => ({...state,workDay: workDay,isOpen: workDay?.estaAbierto || false})),
);
